import { Audience } from '@fluidx/office-fluid-types';

export function mapEnvironmentToAudience(environment: string): Audience {
    switch (environment) {
        case 'bfprod':
        case 'tbprod':
        case 'pfprod':
        case 'unprod':
        case 'usprod':
        case 'prod':
            return 'Production';
        case 'tbprodprv':
        case 'pfprodprv':
        case 'unprodprv':
        case 'usprodprv':
        case 'ppe':
        case 'prodprv':
        case 'ppeprv':
        case 'sdf':
            return 'Dogfood';
        case 'dev':
        case 'developer':
        case 'test':
        default:
            return 'Local';
    }
}
